import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {DialogComponent} from "../../../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../../../ng2-bootstrap-modal/dialog.service";
import {Website} from "../../../website";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DbResponse} from "../../../../../shared/interceptors/db-response";
import {NotifierComponent} from "../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../shared/components/notifier/notification-type";
import {HostingService} from "../../hosting.service";
import * as fromStore from '../../../../../store/index';
import {Store} from '@ngrx/store';
import {Config} from "../../../../../config/config";
import {filter, first, Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {ActivityStatus, IActivity} from "../../../../../activities/activity";


@Component({
    selector: 'db-push-to-live-confirmation',
    templateUrl: 'push-to-live-confirmation.component.html',
    styleUrls: ['push-to-live-confirmation.component.scss'],
    standalone: false
})
export class PushToLiveConfirmationComponent extends DialogComponent<null, boolean> implements OnInit, OnDestroy {

  @Input() website: Website;

  public formSubmitted: boolean;
  public loading: boolean;
  public confirmationSubdomain: any;
  public pushToLiveForm: FormGroup;
  public configHostname: string = Config.hostname;
  public configHostnameList: string[] = Config.hostnameList;
  public ongoingActivityPushToLive$: Observable<IActivity>;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();


  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _dialogService: DialogService,
    private _hostingService: HostingService
  ) {
    super(_dialogService);
  }

  ngOnInit() {
    this.confirmSubDomain();
    this._subscribeToPushToLive();
    // this.getHostName();
    this.formSubmitted = false;
  }

  public confirmSubDomain(): void {
    this.confirmationSubdomain = this.website.name.replace("https://", "");
    this.configHostnameList.map( hostname => {
      if (this.website.name.indexOf(hostname) !== -1) {
        return this.confirmationSubdomain = this.confirmationSubdomain.split("." + hostname)[0].replace("-dev", "");
      }
    });
    this.pushToLiveForm = new FormGroup({
      'subdomain': new FormControl('', [Validators.required, Validators.minLength(1)])
    }, this.checkIfMatchingName(this.confirmationSubdomain, 'subdomain') );
  }

  public getHostName(): void {
    this._hostingService.getUserMainDomain()
    .pipe(filter((response: DbResponse) => !!response),
      first())
      .subscribe((response: DbResponse) => {
        if (response.success) {
          this.configHostname = response.data.domain;
          this.confirmSubDomain();
        }
      });
  }

  public checkIfMatchingName(websiteTitle, siteUrlConfirmationKey: string): any {
    return (group: FormGroup) => {
      const siteUrlConfirmationKeyInput = group.controls[siteUrlConfirmationKey];
      if (websiteTitle !== siteUrlConfirmationKeyInput.value) {
        return siteUrlConfirmationKeyInput.setErrors({notEquivalent: true});
      }
      else {
        return siteUrlConfirmationKeyInput.setErrors(null);
      }
    };
  }

  public cancel(): void {
    this.result = false;
    this.close();
  }

  public confirm(): void {
    this.formSubmitted = true;

    if ( this.pushToLiveForm.valid ) {
      this.loading = true;
        this._hostingService.pushToLive( this.website.id );
    }

  }

  private _subscribeToPushToLive(): void {
    this.ongoingActivityPushToLive$ = this._store.select(fromStore.getPushToLiveOngoingActivity(this.website.id));
    this.ongoingActivityPushToLive$
      .pipe(
        takeUntil(this._destroyStream$),
      )
      .subscribe((activity: IActivity): void => {
        if (activity && activity.status === ActivityStatus.DONE) {
          this._store.dispatch(new fromStore.UpdateWebsiteData(this.website.siblingId.live));
          this._hostingService.clearCache( this.website.siblingId.live );
          this.result = true;
          this.loading = false;
          NotifierComponent.notify(new Notification('Successfully migrated', NotificationType.SUCCESS));
          this.close();
        }
      });
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

}
